/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { AnyAction } from '@reduxjs/toolkit';
import { FrameworkPlanner } from '../types/frameworkUtrs';


type State = ReduxStateLoadable<FrameworkPlanner>
  & { initiativeId: null | string };


const defaultState: State = {
  data: undefined,
  initiativeId: null,
  loaded: false,
  errored: false,
  errorMessage: ''
};
const framework = (state: State = defaultState, action: AnyAction): State => {
  switch (action.type) {
    case actionTypes.LOADING_FRAMEWORK:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: undefined,
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_FRAMEWORK:
      return {
        ...state,
        data: undefined,
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_FRAMEWORK:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.UTRV_UPDATED_FRAMEWORK_UTRV:
      if (!state.loaded) {
        return state;
      }
      const data = {
        ...state.data,
        frameworkUtrs: [
          ...state.data.frameworkUtrs.map(utr => utr._id === action.utrId ? { ...utr, ...action.utr } : utr)
        ]
      };
      return { ...state, data, lastUpdated: Date.now() };
    default:
      return state;

  }

}

export default framework;
